import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ViewDashboard from "../Components/Dashboard/viewDashboard";

const DashBoardRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const rehydrated = useSelector((state) => state?._persist?.rehydrated);
  const isLoggedIn = !!admin?.data?._id;
  const location = useLocation();

  console.log("🔥 DashBoardRoutes:", {
    isLoggedIn,
    rehydrated,
    pathname: location.pathname,
    admin: admin,
  });

  if (!rehydrated) return null;

  if (!isLoggedIn && location.pathname === "/dashboard") {
    return <Navigate to="/" replace />;
  }

  return (
    <Routes>
      <Route path="/dashboard" element={<ViewDashboard />} />
    </Routes>
  );
};

export default DashBoardRoutes;